import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { filter, map, take } from "rxjs";
import { UserSerivice } from "../services/user.service";
import { ROUTES } from "../common/constants";

export const userIsActive: CanActivateFn = () => {
  const router = inject(Router);
  const accountStatusRoute = ROUTES.userAccountStatus;
  return inject(UserSerivice)
    .currentProfile()
    .pipe(
      filter(p => !!p),
      take(1),
      map((profile) => {
        if (profile.active) {
          return true;
        }

        router.navigateByUrl(`${accountStatusRoute}`);
        return false;
      })
    );
};
